var _circle, _path, _path2, _circle2, _circle3, _circle4, _circle5, _path3, _circle6, _circle7, _circle8, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgManagingDataSources(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 413,
    height: 372,
    viewBox: "0 0 413 372",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 232.067,
    cy: 197.882,
    r: 78.2335,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.4844 182.753L368.62 179.17",
    stroke: "black",
    strokeWidth: 4.88361
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M136.657 325.393L287.566 39.6375",
    stroke: "black",
    strokeWidth: 4.88361
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 134.634,
    cy: 329.309,
    r: 41.8458,
    fill: "#14D3A6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.8458,
    cy: 185.578,
    r: 41.8458,
    fill: "black"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 287.462,
    cy: 41.8458,
    r: 41.8458,
    fill: "black"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 371.154,
    cy: 185.578,
    r: 41.8458,
    fill: "#14D3A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M130.995 43.6663L283.823 328.4",
    stroke: "black",
    strokeWidth: 4.88361
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 212.868,
    cy: 185.578,
    r: 78.2335,
    fill: "#3400C8"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 125.537,
    cy: 41.8458,
    r: 41.8458,
    fill: "#14D3A6"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 287.462,
    cy: 329.309,
    r: 41.8458,
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M172.244 195.6C171.994 195.6 171.8 195.532 171.663 195.395C171.526 195.235 171.458 195.042 171.458 194.814V172.491C171.458 172.24 171.526 172.046 171.663 171.91C171.8 171.75 171.994 171.67 172.244 171.67H180.004C182.352 171.67 184.243 172.024 185.679 172.73C187.115 173.437 188.163 174.485 188.824 175.875C189.485 177.243 189.827 178.929 189.85 180.935C189.872 181.96 189.884 182.86 189.884 183.635C189.884 184.41 189.872 185.299 189.85 186.302C189.804 188.398 189.451 190.142 188.79 191.532C188.152 192.899 187.126 193.925 185.713 194.609C184.323 195.27 182.477 195.6 180.175 195.6H172.244ZM174.808 192.694H180.004C181.577 192.694 182.83 192.478 183.765 192.045C184.699 191.612 185.371 190.917 185.782 189.96C186.215 189.002 186.443 187.737 186.465 186.165C186.511 185.481 186.534 184.889 186.534 184.387C186.534 183.863 186.534 183.35 186.534 182.849C186.534 182.325 186.511 181.732 186.465 181.071C186.42 178.861 185.896 177.231 184.893 176.183C183.89 175.112 182.204 174.576 179.833 174.576H174.808V192.694ZM193.02 195.6C192.837 195.6 192.678 195.532 192.541 195.395C192.404 195.258 192.336 195.099 192.336 194.916C192.336 194.802 192.348 194.677 192.37 194.54L200.848 172.423C200.939 172.195 201.065 172.012 201.224 171.876C201.384 171.739 201.623 171.67 201.942 171.67H204.267C204.586 171.67 204.825 171.739 204.985 171.876C205.144 172.012 205.27 172.195 205.361 172.423L213.804 194.54C213.85 194.677 213.873 194.802 213.873 194.916C213.873 195.099 213.804 195.258 213.668 195.395C213.531 195.532 213.371 195.6 213.189 195.6H211.446C211.172 195.6 210.967 195.532 210.83 195.395C210.716 195.258 210.637 195.133 210.591 195.019L208.711 190.165H197.498L195.618 195.019C195.595 195.133 195.515 195.258 195.379 195.395C195.242 195.532 195.037 195.6 194.763 195.6H193.02ZM198.489 187.225H207.719L203.104 175.089L198.489 187.225ZM221.007 195.6C220.779 195.6 220.586 195.532 220.426 195.395C220.289 195.235 220.221 195.042 220.221 194.814V174.713H213.658C213.43 174.713 213.236 174.645 213.076 174.508C212.94 174.348 212.871 174.155 212.871 173.927V172.491C212.871 172.24 212.94 172.046 213.076 171.91C213.236 171.75 213.43 171.67 213.658 171.67H230.135C230.386 171.67 230.579 171.75 230.716 171.91C230.876 172.046 230.955 172.24 230.955 172.491V173.927C230.955 174.155 230.876 174.348 230.716 174.508C230.579 174.645 230.386 174.713 230.135 174.713H223.605V194.814C223.605 195.042 223.526 195.235 223.366 195.395C223.229 195.532 223.036 195.6 222.785 195.6H221.007ZM230.644 195.6C230.461 195.6 230.302 195.532 230.165 195.395C230.028 195.258 229.96 195.099 229.96 194.916C229.96 194.802 229.971 194.677 229.994 194.54L238.472 172.423C238.563 172.195 238.689 172.012 238.848 171.876C239.008 171.739 239.247 171.67 239.566 171.67H241.891C242.21 171.67 242.449 171.739 242.608 171.876C242.768 172.012 242.893 172.195 242.984 172.423L251.428 194.54C251.474 194.677 251.497 194.802 251.497 194.916C251.497 195.099 251.428 195.258 251.291 195.395C251.155 195.532 250.995 195.6 250.813 195.6H249.069C248.796 195.6 248.591 195.532 248.454 195.395C248.34 195.258 248.26 195.133 248.215 195.019L246.335 190.165H235.122L233.242 195.019C233.219 195.133 233.139 195.258 233.002 195.395C232.866 195.532 232.661 195.6 232.387 195.6H230.644ZM236.113 187.225H245.343L240.728 175.089L236.113 187.225Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagingDataSources);
export default __webpack_public_path__ + "static/media/ManagingDataSources.025aa2332715f23e9314b791371c2f58.svg";
export { ForwardRef as ReactComponent };